module.exports = __webpack_public_path__ + "powered_by_google___3Eka_.png";